import axios from 'axios';

export const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api = axios.create({ baseURL });

/* Dummy trade-copier data for looking at the POW Index page without a backend.
   Development only — a production build never reaches this branch, so the module
   is not pulled in. Whether the fixtures actually answer is decided per request
   (see services/copierMocks.js), so switching them on is a URL away rather than
   a rebuild: ?mock=1 on any page turns them on, ?mock=off turns them back off. */
if (process.env.NODE_ENV === 'development') {
  require('./copierMocks').install(api);
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  window.dispatchEvent(new Event('auth:sessionExpired'));
}

let refreshPromise = null;

function refreshAccessToken() {
  if (!refreshPromise) {
    const refreshToken = localStorage.getItem('refreshToken');
    refreshPromise = (refreshToken
      ? axios.post(`${baseURL}/auth/refresh`, { refreshToken })
      : Promise.reject(new Error('No refresh token stored')))
      .then(({ data }) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('refreshToken', data.refreshToken);
        return data.token;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}

api.interceptors.response.use(
  res => res,
  async err => {
    const url = err.config?.url || '';
    const isAuthRoute = url.includes('/auth/login') || url.includes('/auth/refresh');

    if (err.response?.status === 401 && !isAuthRoute && !err.config._retry) {
      err.config._retry = true;
      try {
        const token = await refreshAccessToken();
        err.config.headers.Authorization = `Bearer ${token}`;
        return api(err.config);
      } catch {
        clearSession();
      }
    } else if (err.response?.status === 401 && !isAuthRoute) {
      clearSession();
    }

    return Promise.reject(err);
  }
);

export default api;
